export default {
  SET_SUPPORT: 'WEB_AUTH_N/SET_SUPPORT',
  START_LOGIN: 'WEB_AUTH_N/START_LOGIN',
  START_REGISTER: 'WEB_AUTH_N/START_REGISTER',
}
